import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

export default function AvatarMenu({ title = '', initials = 'DD', children }) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title={title || 'Account'}>
                    <IconButton
                        size="small"
                        sx={{ ml: 2 }}
                        aria-haspopup="true"
                        onClick={handleClick}
                        aria-expanded={open ? 'true' : undefined}
                        aria-controls={open ? 'account-menu' : undefined}>
                        <Avatar sx={{ width: 40, height: 40 }}>{initials}</Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 4px 20px rgba(0,0,0,0.15))',
                        mt: 1.5,
                        backgroundColor: 'var(--color-card, #FFFFFF)',
                        color: 'var(--color-text, #0F172A)',
                        border: '1px solid var(--color-border, #E2E8F0)',
                        borderRadius: '12px',
                        '& .MuiMenuItem-root': {
                            color: 'var(--color-text, #0F172A)',
                            '&:hover': {
                                backgroundColor: 'var(--color-primary-light, #ECFDF5)',
                            },
                        },
                        '& .MuiDivider-root': {
                            borderColor: 'var(--color-border, #E2E8F0)',
                        },
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                {children}
            </Menu>
        </React.Fragment>
    );
}